// This file was automatically generated from app.settings.typeSettings.html.
// Please don't edit this file by hand.

goog.provide('el8.template.app.settings.typeSettings');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.typeSettings.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h1 class="el8PageTitle">Report & Visit Note Categories</h1><div class="mb30" id="additional-vitals-toggle-section"><div class="ebs-clearfix"><div class="el8ToggleContainer ebs-pull-right ml20"><input type="radio" name="additionalVitalsEnabled" value="true" id="additional-vitals-enabled-true" class="el8Toggle el8ToggleTrue" /><label for="additional-vitals-enabled-true" class="el8ToggleLabel el8ToggleLabelOn">Yes</label><input type="radio" name="additionalVitalsEnabled" value="false" id="additional-vitals-enabled-false" class="el8Toggle el8ToggleFalse" /><label for="additional-vitals-enabled-false" class="el8ToggleLabel el8ToggleLabelOff">No</label><span class="el8ToggleSelection"></span></div><div class="ebs-row"><div class="ebs-col-xs-9"><div class="padt6 el8Bold">Display additional vitals fields in visit notes</div><p class="ebs-text-muted padt3">The current set of additional vital fields are: body fat %, change in dry lean mass, change in body fat mass, waist circumference, and ketones</p></div></div></div><div class="confirm-msg ebs-pull-right ebs-text-right mt5 el8StandardFontSize el8Bold"></div></div><h3 class="el8SectionHeader mt20">Report Categories<span class="el8StandardFontSize el8NormalText el8ItalicText ebs-text-muted ml10">(Drag and drop to re-order the report categories in the table below)</span></h3><div class="report-type-section mb10"><ul class="report-type-list el8Loading ebs-list-unstyled"></ul><button class="add-trigger ebs-btn ebs-btn-default">+ Add Report Category</button></div><h3 class="el8SectionHeader mt20">Visit Note Categories <span class="el8StandardFontSize el8NormalText el8ItalicText ebs-text-muted ml10">(Drag and drop to re-order)</span></h3><div class="visit-type-section mb30">');
  el8.template.app.settings.typeSettings.visitTypeTableHeader(null, output);
  output.append('<ul class="visit-type-list el8Loading ebs-list-unstyled"></ul><button class="add-trigger ebs-btn ebs-btn-default">+ Add Visit Note Category</button></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.typeSettings.visitTypeList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var visitTypeList7668 = opt_data.visitTypes;
  var visitTypeListLen7668 = visitTypeList7668.length;
  for (var visitTypeIndex7668 = 0; visitTypeIndex7668 < visitTypeListLen7668; visitTypeIndex7668++) {
    var visitTypeData7668 = visitTypeList7668[visitTypeIndex7668];
    output.append('<li class="curated-list-item el8SettingsSortListItem" data-id="', soy.$$escapeHtml(visitTypeData7668.id), '"><span class="sort-handle el8Gripper"></span><div class="ml20 ebs-clearfix"><div class="el8InlineBlock el8StandardFontSize w60 el8CursorDefault">', soy.$$escapeHtml(visitTypeData7668.name), (visitTypeIndex7668 == 0) ? '<a class="ml10 default-visit-tooltip el8FilledStar"></a>' : '', '</div><div class="el8InlineBlock ebs-text-center w20">', (visitTypeData7668.isMuOfficeVisit) ? '<span class="el8CheckmarkIcon"></span>' : '', '</div><div class="el8InlineBlock ebs-text-right w20">', (visitTypeData7668.name != 'Staff Procedure Note') ? '<a class="edit-trigger el8Link">edit</a>' + ((opt_data.visitTypes.length > 1) ? '<a class="remove-trigger el8Link ml10">remove</a>' : '') : '', '</div></div></li>');
  }
  output.append('<li class="new-form-stub"></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.typeSettings.visitTypeForm = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form class="el8SettingsSortListForm"><div class="padl10 padt5"><div class="el8FieldSectionOverflow el8InlineBlock el8EditorTextareaWrap w58 padt5 el8VAlignTop"><input name="name" class="w100 ebs-form-control" /></div><div class="el8FieldSectionOverflow el8ToggleContainer el8InlineBlock mt2 ml20"><input type="radio" name="isMuOfficeVisit" value="true" id="is-mu-office-visit-true-toggle" class="el8Toggle el8ToggleTrue" checked /><label for="is-mu-office-visit-true-toggle" class="el8ToggleLabel el8ToggleLabelOn">Yes</label><input type="radio" name="isMuOfficeVisit" value="false" id="is-mu-office-visit-false-toggle" class="el8Toggle el8ToggleFalse" /><label for="is-mu-office-visit-false-toggle" class="el8ToggleLabel el8ToggleLabelOff">No</label><span class="el8ToggleSelection"></span></div></div><div class="form-buttons el8InlineBlock el8AlignLeft w100 pad10"></div></form>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.typeSettings.visitTypeTableHeader = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div><div class="el8InlineBlock w62 el8StrongMiniHeading padv10">Visit Note Category<a class="ml10 visit-note-type-tooltip el8InfoTipIcon"></a></div><div class="el8InlineBlock w38 el8StrongMiniHeading padv10">Count for MIPS?<a class="ml10 mu-office-visit-tooltip el8InfoTipIcon"></a></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.typeSettings.visitNoteTypeTooltip = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('You can assign your notes a Visit Note Category and it will appear in the header of your Visit Note to categorize that note.');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.typeSettings.muOfficeVisitTooltip = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('Determines whether these notes count as "Office Visits" / "Patients Seen" in the ACI Dashboard.');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.typeSettings.defaultVisitTooltip = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('This is your practice\'s default Visit Note Category. New Visit Notes will be assigned this type unless otherwise specified in the Appointment Type.');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.typeSettings.visitTypeDeleteConfirmation = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('Any existing visit notes labeled as "', soy.$$escapeHtml(opt_data.visitType.name), '" will retain that visit note category, but you will no longer be able to create new "', soy.$$escapeHtml(opt_data.visitType.name), '" notes.\n\n<span class="el8Bold">Are you sure you want to remove this visit note category?</span>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.typeSettings.visitTypeMuChangeConfirmation = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('You\'ve changed this visit note category to ', (! opt_data.isMuOfficeVisit) ? 'no longer ' : '', 'count as an eligible office visit for ACI attestation. <span class="el8Bold">This will not affect calculations before today, but will go into effect from now on.</span>\n\n<span class="el8Bold">Are you sure you want to continue?</span>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.typeSettings.reportTypeTableHeader = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div><div class="el8InlineBlock w42 el8StrongMiniHeading pad10">Report Category</div><div class="el8InlineBlock w40 el8StrongMiniHeading pad10">Reports Tab Label</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.typeSettings.reportTypeList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="report-tab-preview mb10">');
  el8.template.app.settings.typeSettings.reportTabPreview(opt_data, output);
  output.append('</div>');
  el8.template.app.settings.typeSettings.reportTypeTableHeader(null, output);
  var groupList7719 = opt_data.groupedReportTypes;
  var groupListLen7719 = groupList7719.length;
  for (var groupIndex7719 = 0; groupIndex7719 < groupListLen7719; groupIndex7719++) {
    var groupData7719 = groupList7719[groupIndex7719];
    output.append('<div class="el8BgGrayLight padv3 padl5 ebs-text-muted">Page ', soy.$$escapeHtml(groupIndex7719 + 1), '</div>');
    var reportTypeList7723 = groupData7719;
    var reportTypeListLen7723 = reportTypeList7723.length;
    for (var reportTypeIndex7723 = 0; reportTypeIndex7723 < reportTypeListLen7723; reportTypeIndex7723++) {
      var reportTypeData7723 = reportTypeList7723[reportTypeIndex7723];
      output.append('<li class="curated-list-item el8SettingsSortListItem" data-id="', soy.$$escapeHtml(reportTypeData7723.id), '"><span class="sort-handle el8Gripper"></span><div class="ml20 ebs-clearfix"><div class="el8InlineBlock el8StandardFontSize w50">', soy.$$escapeHtml(reportTypeData7723.userLabel), ' Reports</div><div class="el8InlineBlock el8AlignLeft w40">', soy.$$escapeHtml(reportTypeData7723.nickname), '</div><div class="el8InlineBlock ebs-text-right w10">', (reportTypeData7723.reportTypeLabel != 'Lab' && reportTypeData7723.reportTypeLabel != 'Imaging' && reportTypeData7723.reportTypeLabel != 'Consultation' && reportTypeData7723.reportTypeLabel != 'PatientForm') ? '<a class="remove-trigger el8Link ml10">delete</a>' : '<div class="el8SystemText el8ItalicText ml10">required</div>', '</div></div></li>');
    }
  }
  output.append('<li class="new-form-stub"></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.typeSettings.reportTabPreview = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var groupList7741 = opt_data.groupedReportTypes;
  var groupListLen7741 = groupList7741.length;
  for (var groupIndex7741 = 0; groupIndex7741 < groupListLen7741; groupIndex7741++) {
    var groupData7741 = groupList7741[groupIndex7741];
    output.append('<div class="el8SettingsReportTypeRow">Page ', soy.$$escapeHtml(groupIndex7741 + 1), ': ');
    var reportTypeList7745 = groupData7741;
    var reportTypeListLen7745 = reportTypeList7745.length;
    for (var reportTypeIndex7745 = 0; reportTypeIndex7745 < reportTypeListLen7745; reportTypeIndex7745++) {
      var reportTypeData7745 = reportTypeList7745[reportTypeIndex7745];
      output.append('<span class="el8SettingsReportTypeTab">', soy.$$escapeHtml(reportTypeData7745.nickname), '</span>');
    }
    output.append('</div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.typeSettings.reportTypeForm = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form class="el8SettingsSortListForm el8OverflowVisible"><div class="el8InlineBlock mv5 w40"><select name="reportTypeId">');
  var reportTypeList7754 = opt_data.availableTypes;
  var reportTypeListLen7754 = reportTypeList7754.length;
  for (var reportTypeIndex7754 = 0; reportTypeIndex7754 < reportTypeListLen7754; reportTypeIndex7754++) {
    var reportTypeData7754 = reportTypeList7754[reportTypeIndex7754];
    output.append('<option value="', soy.$$escapeHtml(reportTypeData7754.id), '">', soy.$$escapeHtml(reportTypeData7754.userLabel), '</option>');
  }
  output.append('</select></div><div class="el8InlineBlock ebs-text-center mv5 w40"><p class="report-type-label"></p></div><div class="el8InlineBlock ebs-text-right form-buttons ebs-pull-right mt5"></div></form>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.typeSettings.reportTypeAddOrderTabConfirmation = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('Adding a ', soy.$$escapeHtml(opt_data.nickname), ' tab will move any existing ', soy.$$escapeHtml(opt_data.userLabel), ' orders from your Consult tab into the new tab. Continue?');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.typeSettings.reportTypeDeleteTabConfirmation = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isOrderLinked) ? 'Removing the ' + soy.$$escapeHtml(opt_data.nickname) + ' tab will move any existing ' + soy.$$escapeHtml(opt_data.userLabel) + ' orders to your Consult tab, though the tab will continue to be visible in any charts that already have ' + soy.$$escapeHtml(opt_data.userLabel) + ' Reports. Remove this tab?' : 'Are you sure you want to remove the ' + soy.$$escapeHtml(opt_data.nickname) + ' report tab from your charts? It will continue to be visible in charts that already have ' + soy.$$escapeHtml(opt_data.userLabel) + ' Reports.');
  if (!opt_sb) return output.toString();
};
